import BannerManagement from "views/Banner Management/BannerManagement";
import BrandManagement from "views/BrandManagement/BrandManagement";
import Category from "views/Category/Category";
import Customer from "views/Customer/Customer";
import CustomerDetail from "views/Customer/CustomerDetail";
import Dashboard from "views/dashboard/Dashboard.js";
import OderDetaits from "views/Order/OderDetaits";
import Order from "views/Order/Order";
import Ourstaff from "views/Ourstaff/Ourstaff";
import Product from "views/Product/Product";
import Promo from "views/Promo/Promo";
import Ratelist from "views/Ratelist/Ratelist";
import Rider from "views/Rider/Rider";
import Role from "views/Role/Role";
import Setting from "views/Setting/Setting";
// import DeliveryCharges from "views/Delivery Charges/DeliveryCharges";
import Support from "views/Support/Support";
import SupportDetail from "views/Support/SupportDetail";
import Unit from "views/Unit/Unit";
import Discount from "views/Discounts/Discount";
import DiscountCSV from "views/Discounts/DiscountCSV/DiscountCSV";
import Bank from "views/BankTransfer/Bank";
import Pushnotification from "views/Pushnotification/Pushnotification";
import Deliverycharges from "views/Delivery Charges/DeliveryCharges";
import Appmanagment from "views/Appmanagment/Appmanagment";
import Bannerappmanagment from "components/appmanagment/Bannerappmanagment/Bannerappmanagment";
import Mystreybox from "components/appmanagment/mysterybox/Mystreybox";
import Apppushnotification from "components/pushnotification/Apppushnotification";
import Bannerwebsitemanagment from "components/Bannerwebsitemanagment/Bannerwebsitemanagment";
import Coupandiscount from "components/Discount/Coupandiscount";
import Bulkdiscount from "components/Discount/Bulkdiscount";
import Categorydiscount from "components/Discount/Categorydiscount";
import Quickanalytics from "components/Quickanalytics/Quickanalytics";
import Collection from "components/collection/Collection";
import Createcollection from "components/collection/Createcollection";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/product",
    name: "Product",
    component: Product,
    layout: "/admin",
  },
  {
    path: "/category",
    name: "Category",
    component: Category,
    layout: "/admin",
  },
  {
    path: "/order",
    name: "Order",
    component: Order,
    layout: "/admin",
  },
  {
    path: "/customer",
    name: "Customer",
    component: Customer,
    layout: "/admin",
  },
  {
    path: "/ourstaff",
    name: "Ourstaff",
    component: Ourstaff,
    layout: "/admin",
  },
  {
    path: "/rider",
    name: "Rider",
    component: Rider,
    layout: "/admin",
  },
  {
    path: "/promo",
    name: "Promo",
    component: Promo,
    layout: "/admin",
  },
  {
    path: "/support",
    name: "Support",
    component: Support,
    layout: "/admin",
  },
  {
    path: "/setting",
    name: "Setting",
    component: Setting,
    layout: "/admin",
  },
  {
    path: "/customerdetail",
    name: "CustomerDetail",
    component: CustomerDetail,
    layout: "/admin",
  },
  {
    path: "/orderdetail",
    name: "OrderDetail",
    component: OderDetaits,
    layout: "/admin",
  },
  {
    path: "/supportdetail",
    name: "SupportDetail",
    component: SupportDetail,
    layout: "/admin",
  },
  {
    path: "/role",
    name: "Role",
    component: Role,
    layout: "/admin",
  },
  {
    path: "/brandmanagement",
    name: "Brand Management",
    component: BrandManagement,
    layout: "/admin",
  },
  {
    path: "/unit",
    name: "Unit",
    component: Unit,
    layout: "/admin",
  },
  {
    path: "/bannermanagement",
    name: "Banner Management",
    component: BannerManagement,
    layout: "/admin",
  },
  {
    path: "/deliverycharges",
    name: "Delivery Charges",
    component: Deliverycharges,
    layout: "/admin",
  },
  {
    path: "/appmanagment",
    name: "App Management",
    component: Appmanagment,
    layout: "/admin",
  },
  {
    path: "/bannerappmanagment",
    name: "Banner App Managment",
    component: Bannerappmanagment,
    layout: "/admin",
  },
  {
    path: "/mystreybox",
    name: "Banner Mystrey Box",
    component: Mystreybox,
    layout: "/admin",
  },

  {
    path: "/apppushnotification",
    name: "App push notification",
    component: Apppushnotification,
    layout: "/admin",
  },

  {
    path: "/bannerwbsitemanagment",
    name: "Banner Website Managment",
    component: Bannerwebsitemanagment,
    layout: "/admin",
  },

  {
    path: "/pushnotification",
    name: "Push Notification",
    component: Pushnotification,
    layout: "/admin",
  },
  {
    path: "/discount",
    name: "Discount",
    component: Discount,
    layout: "/admin",
  },


    {
    path: "/coupandiscount",
    name: "Coupan",
    component: Coupandiscount ,
    layout: "/admin",
  },

    {
    path: "/bulkdiscount",
    name: "Bulk Discount",
    component: Bulkdiscount ,
    layout: "/admin",
  },
  {
    path: "/discountCSV",
    name: "Discount CSV",
    component: DiscountCSV,
    layout: "/admin",
  },
   {
    path: "/quickanalytics",
    name: "Quick analytics",
    component: Quickanalytics,
    layout: "/admin",
  },
  {
    path: "/categorydiscount",
    name: "Category Discount",
    component: Categorydiscount,
    layout: "/admin",
  },
  {
    path: "/banktransfer",
    name: "Bank Information",
    component: Bank,
    layout: "/admin",
  },
  {
    path: "/ratelist",
    name: "Ratelist",
    component: Ratelist,
    layout: "/admin",
  },
    {
    path: "/collection",
    name: "Collection",
    component: Collection,
    layout: "/admin",
  },
    {
    path: "/createcolllection",
    name: "Create collection",
    component: Createcollection,
    layout: "/admin",
  },
];
export default routes;
